<template>
  <lego-segment-wrapper
    primary
    :small="small"
    :modelValue="props.modelValue"
    @update:modelValue="changeEventLeve"
  >
    <lego-segment-button :value="$const.EVENT_LEVEL.ALL">All</lego-segment-button>
    <lego-segment-button :value="$const.EVENT_LEVEL.FATAL">
      <div class="event-icon event-icon--fatal">F</div>
      <span>Fatal</span>
    </lego-segment-button>
    <lego-segment-button :value="$const.EVENT_LEVEL.WARNING">
      <div class="event-icon event-icon--warning">W</div>
      <span>Warning</span>
    </lego-segment-button>
    <lego-segment-button :value="$const.EVENT_LEVEL.INFORM">
      <div class="event-icon event-icon--inform">I</div>
      <span>Inform</span>
    </lego-segment-button>
  </lego-segment-wrapper>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { defineProps, defineEmits } from 'vue';
const { $const } = getCurrentInstance().appContext.config.globalProperties;

const props = defineProps({
  modelValue: { type: Array },
  small: { type: Boolean }
});

const emits = defineEmits(['update:modelValue']);

const changeEventLeve = (value) => {
  let newValue;
  const all = $const.EVENT_LEVEL.ALL;

  if (!value.length || value[value.length - 1] === all) {
    newValue = [all];
  } else {
    newValue = value.filter((level) => level !== all);
  }

  emits('update:modelValue', newValue);
};
</script>

<style lang="scss" scoped>
.lego-segment-wrapper {
  display: flex;
  .lego-segment-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 13px;
    &.lego-segment-button--small {
      padding: 8px 12px;
      font-size: 12px;
      gap: 4px;
    }
    .event-icon {
      width: 16px;
      height: 16px;
      font-size: 10px;
      font-weight: 700;
      border-radius: 100px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      &--fatal {
        background-color: #fb6a72;
      }
      &--warning {
        background-color: #ffcf33;
      }
      &--inform {
        background-color: #868d9c;
      }
    }
  }

  :deep(.lego-segment-button--small) {
    .dangerIcon,
    em {
      width: 16px !important;
      height: 16px !important;
      font-size: 10px !important;
    }
  }
}
</style>
